import { css, SerializedStyles } from '@emotion/core';
import { Theme, normalText, titleText, helpText } from 'features/Theme';

const style = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  headerText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
  `,

  subHeadingContainer: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)}
    margin-top: ${theme.mui.spacing(3)}px;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
};

export default style;
